/**
 * Reports — a scanned or received report, coded and filed onto a chart.
 *
 * Replaces `src/api/reportApi.js`: `#requestAutoAddReport`, `#saveExtraction`
 * and `#requestCommitAutoAddReport`.
 *
 * A report starts as a draft built from a PDF in the workbench
 * (`documents.js`), gets its codes, and is committed onto the chart — the same
 * draft-then-commit shape the C-CDA pipeline has, and for the same reason:
 * nothing an operator has not committed is clinically visible.
 *
 * `createReportDraft` posts to a PDF but is audited as a **report**, because the
 * audit type names the resource that came into being.
 */

import api from './client';

/** `?filter[patient_id]`, `[category]`, `[npi]`. */
export function listReports(params = {}) {
  return api.list('/reports', params);
}

export function getReport(reportId) {
  return api.get(`/reports/${reportId}`);
}

export function downloadReport(reportId) {
  return api.download(`/reports/${reportId}/content`);
}

/**
 * File a report from a PDF already in the workbench: `pdf_document_id`,
 * `patient_id`, `report_date`, the category and procedure and diagnosis codes.
 */
export function createReport(payload) {
  return api.post('/reports', payload);
}

/** Start a draft from a PDF; the extraction stays editable until committed. */
export function createReportDraft(pdfId, payload) {
  return api.post(`/pdf-documents/${pdfId}/report-draft`, payload);
}

/** The state transition, as a sub-resource rather than a verb in the path. */
export function commitReport(reportId) {
  return api.post(`/reports/${reportId}/commit`);
}

export default {
  listReports, getReport, downloadReport, createReport, createReportDraft,
  commitReport,
};
